import Button from '@components/atoms/button'
import NumberedStarCard from '@components/common/numbered-star-card'

const PRINCIPLES = [
  {
    id: 1,
    title: 'Always put students first.',
    description:
      "We prioritize what's best for students, even if it's harder for us. When questions arise or someone struggles, we pause, adjust, and guide them because their learning always comes first.",
    numberClass: 'text-violet-100',
  },
  {
    id: 2,
    title: 'Keep a high bar for excellence.',
    description:
      'We aim to improve continuously, not to be perfect. By preparing lessons carefully, refining what works, and focusing on details, we make every class better than the last.',
    numberClass: 'text-yellow-200',
  },
  {
    id: 3,
    title: 'Stay curious and keep growing.',
    description:
      "We embrace learning at every step. When something doesn't work, we explore why, try new approaches, and seek feedback because curiosity drives better teaching.",
    numberClass: 'text-blue-200',
  },
  {
    id: 4,
    title: 'Act with integrity always.',
    description:
      'We do what we say, admit mistakes, and treat everyone with respect. Trust is earned through consistent ethical actions, and we seek guidance when unsure.',
    numberClass: 'text-orange',
  },
  {
    id: 5,
    title: 'Make mistakes but learn from them',
    description:
      'Mistakes are acceptable and expected. But once they happen, we reflect, learn, and use them to grow stronger together.',
    numberClass: 'text-green-100',
  },
  {
    id: 6,
    title: 'Work as one team, one mission.',
    description:
      'We collaborate, share successes, and support each other. While opinions may differ, we align on our mission, helping students love learning together.',
    numberClass: 'text-red-200',
  },
]

type Props = {
  handleBecomeTeacher: () => void
}

const TeachingPrinciples = ({ handleBecomeTeacher }: Props) => (
  <div className="bg-blue-50 bg-opacity-25">
    <div className="w-full relative flex flex-col items-center container mx-auto px-5 py-12 lg:py-16 leading-tight text-grey">
      <h2 className="max-w-4xl mx-auto pb-3 text-2xl text-center text-grey lg:text-4xl font-600">
        The principles that guide Codingal teachers
      </h2>
      <p className="text-grey text-lg text-center max-w-4xl mx-auto">
        As you join our team, these values will guide you. They&apos;ll help you
        make decisions, navigate challenges, and understand what success looks
        like here.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mt-10">
        {PRINCIPLES.map((value) => (
          <NumberedStarCard
            key={value.id}
            id={value.id}
            title={value.title}
            description={value.description}
            textColor={value.numberClass}
            className="p-4"
          />
        ))}
      </div>

      <div className="flex justify-center mt-10">
        <Button
          variant="solid"
          intent="primary"
          size="lg"
          onClick={handleBecomeTeacher}
          className="w-full sm:w-auto"
        >
          Become a teacher
        </Button>
      </div>
    </div>
  </div>
)

export default TeachingPrinciples
